<template>
  <router-view />
</template>

<script>
window.addEventListener('resize', () => {
  const width = window.document.documentElement.getBoundingClientRect().width
  document.querySelector('html').style = `font-size: ${width / 1920 * 10}px`
})
</script>
<style lang="scss">
html {
  font-size: 10px;
}

body {
  font-size: 1.4rem;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:global(.el-dialog) {
  border-radius: 8px;
}
</style>
